var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-row",
    { attrs: { gutter: 24 } },
    [
      _c(
        "a-col",
        { attrs: { md: 24 } },
        [
          _c(
            "a-card",
            { style: _vm.cardStyle, attrs: { bordered: false } },
            [
              _vm.proxyMode
                ? _c(
                    "div",
                    { staticClass: "proxy-banner" },
                    [
                      _c("a-icon", { attrs: { type: "info-circle" } }),
                      _vm._v(
                        " 已进入门店后台（" +
                          _vm._s(_vm.proxyStoreName) +
                          "），当前总店标签页同步切换为门店身份\n        "
                      ),
                      _c(
                        "a",
                        {
                          staticClass: "proxy-back",
                          on: { click: _vm.handleBackToHq },
                        },
                        [_vm._v("返回总店")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "a-tabs",
                {
                  on: { change: _vm.onTabChange },
                  model: {
                    value: _vm.activeTab,
                    callback: function ($$v) {
                      _vm.activeTab = $$v
                    },
                    expression: "activeTab",
                  },
                },
                [
                  _c("a-tab-pane", { key: "list", attrs: { tab: "门店列表" } }),
                  _c("a-tab-pane", {
                    key: "recycle",
                    attrs: { tab: "回收站" },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "table-page-search-wrapper" },
                [
                  _c(
                    "a-form",
                    {
                      attrs: { layout: "inline" },
                      nativeOn: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          )
                            return null
                          return _vm.searchQuery.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "a-row",
                        { attrs: { gutter: 24 } },
                        [
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                { attrs: { label: "按关键字：" } },
                                [
                                  _c("a-input", {
                                    staticStyle: { width: "180px" },
                                    attrs: { placeholder: "请输入关键字搜索" },
                                    model: {
                                      value: _vm.queryParam.keyword,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.queryParam, "keyword", $$v)
                                      },
                                      expression: "queryParam.keyword",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                { attrs: { label: "按门店类别：" } },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      staticStyle: { width: "140px" },
                                      attrs: {
                                        placeholder: "请选择",
                                        "allow-clear": "",
                                      },
                                      on: { change: _vm.searchQuery },
                                      model: {
                                        value: _vm.queryParam.storeType,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryParam,
                                            "storeType",
                                            $$v
                                          )
                                        },
                                        expression: "queryParam.storeType",
                                      },
                                    },
                                    [
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "1" } },
                                        [_vm._v("直营店")]
                                      ),
                                      _c(
                                        "a-select-option",
                                        { attrs: { value: "2" } },
                                        [_vm._v("加盟店")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "a-col",
                            { attrs: { md: 6, sm: 24 } },
                            [
                              _c(
                                "a-form-item",
                                { attrs: { label: "按门店区域：" } },
                                [
                                  _c(
                                    "a-select",
                                    {
                                      staticStyle: { width: "140px" },
                                      attrs: {
                                        placeholder: "请选择",
                                        "allow-clear": "",
                                      },
                                      on: { change: _vm.searchQuery },
                                      model: {
                                        value: _vm.queryParam.provinceId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryParam,
                                            "provinceId",
                                            $$v
                                          )
                                        },
                                        expression: "queryParam.provinceId",
                                      },
                                    },
                                    _vm._l(_vm.provinceOptions, function (p) {
                                      return _c(
                                        "a-select-option",
                                        {
                                          key: p.value,
                                          attrs: { value: p.value },
                                        },
                                        [_vm._v(_vm._s(p.label))]
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("a-col", { attrs: { md: 6, sm: 24 } }, [
                            _c(
                              "span",
                              {
                                staticClass: "table-page-search-submitButtons",
                                staticStyle: {
                                  float: "left",
                                  overflow: "hidden",
                                },
                              },
                              [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.searchQuery },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-left": "8px" },
                                    on: { click: _vm.searchReset },
                                  },
                                  [_vm._v("重置")]
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "table-operator",
                  staticStyle: { "margin-top": "5px" },
                },
                [
                  _vm.activeTab === "list" && _vm.btnEnableList.indexOf(1) > -1
                    ? _c(
                        "a-button",
                        {
                          attrs: { type: "primary", icon: "plus" },
                          on: { click: _vm.handleAdd },
                        },
                        [_vm._v("新增门店")]
                      )
                    : _vm._e(),
                  _vm.activeTab === "list"
                    ? _c(
                        "span",
                        {
                          staticClass: "field-tip",
                          staticStyle: { "margin-left": "10px" },
                        },
                        [
                          _vm._v(
                            "新增门店将创建独立租户与主账号（仅总店可操作）"
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("a-table", {
                ref: "table",
                attrs: {
                  size: "middle",
                  bordered: "",
                  rowKey: "id",
                  columns: _vm.columns,
                  dataSource: _vm.dataSource,
                  pagination: _vm.ipagination,
                  loading: _vm.loading,
                },
                on: { change: _vm.handleTableChange },
                scopedSlots: _vm._u([
                  {
                    key: "nameSlot",
                    fn: function (text, record) {
                      return [
                        _c(
                          "div",
                          { staticClass: "store-name" },
                          [
                            _c("span", [
                              _vm._v(_vm._s(record.storeName || record.name)),
                            ]),
                            String(record.isMain) === "1"
                              ? _c("a-tag", { attrs: { color: "blue" } }, [
                                  _vm._v("总店"),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "statusSlot",
                    fn: function (text, record) {
                      return [
                        _c(
                          "a-tag",
                          {
                            attrs: {
                              color:
                                String(record.status) === "1" ? "green" : "red",
                            },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                String(record.status) === "1" ? "启用" : "停用"
                              )
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                  {
                    key: "modelSlot",
                    fn: function (text, record) {
                      return [
                        _c("div", { staticClass: "store-model" }, [
                          String(record.goodsModel) === "1"
                            ? _c(
                                "span",
                                [
                                  _vm._v("模式一："),
                                  _c("a-tag", { attrs: { color: "green" } }, [
                                    _vm._v("同步总店商品"),
                                  ]),
                                ],
                                1
                              )
                            : String(record.goodsModel) === "2"
                            ? _c(
                                "span",
                                [
                                  _vm._v("模式二："),
                                  _c("a-tag", [_vm._v("普通商品权限")]),
                                ],
                                1
                              )
                            : _c(
                                "span",
                                [
                                  _vm._v("模式三："),
                                  _c("a-tag", { attrs: { color: "red" } }, [
                                    _vm._v("超级商品权限"),
                                  ]),
                                ],
                                1
                              ),
                          _c(
                            "a",
                            {
                              staticClass: "model-edit",
                              on: {
                                click: function ($event) {
                                  return _vm.handleGoodsModel(record)
                                },
                              },
                            },
                            [_vm._v("修改")]
                          ),
                        ]),
                      ]
                    },
                  },
                  {
                    key: "action",
                    fn: function (text, record) {
                      return _c(
                        "span",
                        {},
                        [
                          _vm.activeTab === "list"
                            ? [
                                _c(
                                  "a-button",
                                  {
                                    staticStyle: { "margin-right": "8px" },
                                    attrs: { size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleEnterBackend(record)
                                      },
                                    },
                                  },
                                  [_vm._v("进入后台")]
                                ),
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleEdit(record)
                                      },
                                    },
                                  },
                                  [_vm._v("编辑")]
                                ),
                                _c("a-divider", {
                                  attrs: { type: "vertical" },
                                }),
                                _vm.btnEnableList.indexOf(1) > -1
                                  ? _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDelete(record)
                                          },
                                        },
                                      },
                                      [_vm._v("删除")]
                                    )
                                  : _vm._e(),
                              ]
                            : [
                                _c(
                                  "a",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleRestore(record)
                                      },
                                    },
                                  },
                                  [_vm._v("恢复")]
                                ),
                                _c("a-divider", {
                                  attrs: { type: "vertical" },
                                }),
                                _vm.btnEnableList.indexOf(1) > -1
                                  ? _c(
                                      "a",
                                      {
                                        on: {
                                          click: function ($event) {
                                            return _vm.handlePurge(record)
                                          },
                                        },
                                      },
                                      [_vm._v("彻底删除")]
                                    )
                                  : _vm._e(),
                              ],
                        ],
                        2
                      )
                    },
                  },
                ]),
              }),
              _c("goods-model-modal", {
                ref: "goodsModelModal",
                on: { ok: _vm.loadData },
              }),
              _c(
                "a-modal",
                {
                  attrs: {
                    title: "新增门店",
                    visible: _vm.addVisible,
                    confirmLoading: _vm.addSaving,
                    maskClosable: false,
                  },
                  on: {
                    ok: _vm.handleAddOk,
                    cancel: function ($event) {
                      _vm.addVisible = false
                    },
                  },
                },
                [
                  _c(
                    "a-form",
                    { staticClass: "add-form" },
                    [
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "门店简称",
                            required: "",
                            labelCol: { span: 5 },
                            wrapperCol: { span: 18 },
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder:
                                "门店简称（招牌字号，区别于营业执照企业全称）",
                            },
                            model: {
                              value: _vm.addForm.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "name", $$v)
                              },
                              expression: "addForm.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "门店类别",
                            required: "",
                            labelCol: { span: 5 },
                            wrapperCol: { span: 18 },
                          },
                        },
                        [
                          _c(
                            "a-radio-group",
                            {
                              model: {
                                value: _vm.addForm.storeType,
                                callback: function ($$v) {
                                  _vm.$set(_vm.addForm, "storeType", $$v)
                                },
                                expression: "addForm.storeType",
                              },
                            },
                            [
                              _c("a-radio", { attrs: { value: "1" } }, [
                                _vm._v("直营店"),
                              ]),
                              _c("a-radio", { attrs: { value: "2" } }, [
                                _vm._v("加盟店"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "老板姓名",
                            required: "",
                            labelCol: { span: 5 },
                            wrapperCol: { span: 18 },
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              placeholder: "门店老板真实姓名（主账号姓名）",
                            },
                            model: {
                              value: _vm.addForm.bossName,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "bossName", $$v)
                              },
                              expression: "addForm.bossName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "主账号登录名",
                            required: "",
                            labelCol: { span: 5 },
                            wrapperCol: { span: 18 },
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              autocomplete: "off",
                              placeholder: "门店后台主账号登录名",
                            },
                            model: {
                              value: _vm.addForm.loginName,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "loginName", $$v)
                              },
                              expression: "addForm.loginName",
                            },
                          }),
                          _c("div", { staticClass: "field-tip" }, [
                            _vm._v("账号请不要用中文"),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        "a-form-item",
                        {
                          attrs: {
                            label: "初始密码",
                            required: "",
                            labelCol: { span: 5 },
                            wrapperCol: { span: 18 },
                          },
                        },
                        [
                          _c("a-input", {
                            attrs: {
                              type: "password",
                              autocomplete: "off",
                              placeholder: "主账号初始密码",
                            },
                            model: {
                              value: _vm.addForm.initPassword,
                              callback: function ($$v) {
                                _vm.$set(_vm.addForm, "initPassword", $$v)
                              },
                              expression: "addForm.initPassword",
                            },
                          }),
                          _c("div", { staticClass: "field-tip" }, [
                            _vm._v(
                              "密码至少要有数字和小写字母，并且长度至少6位"
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("a-alert", {
                    staticStyle: { "margin-top": "4px" },
                    attrs: {
                      type: "info",
                      "show-icon": "",
                      message: "创建后将生成独立租户与主账号",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }